<template>
    <div tabindex="18" class="grid-x testimonials-carousel">
          <div class="small-1 cell control-cont" @click="previous">
            <img tabindex="18" class="prev-arrow" src="@/assets/img/icons/left.png" @keypress="previous" />
          </div>
          <div class="small-10 cell">
            <div class="button-container">
             <!-- Seems strange to use the index in this list, but if we use the slide's ID,
             the buttons move order when the carousel moves, which we don't want. -->
              <testimonial-carousel-button
                v-for="(slide, index) in renderedSlides"
                :key="index"
                :id="index"
                :currentSlide="currentSlide === index"
                @changeSlide="moveCarousel"
              />
            </div>
            <div class="carousel-view">
              <transition-group tag="div" class="transition-group carousel" name='carousel'>
                <div v-for="slide in renderedSlides" style="width: 100%; " :key="slide.id">
                <testimonial-carousel-slide
                  :img="slide.img"
                  :quote="slide.quote"
                  :name="slide.name"
                  :position="slide.position"
                  :logo="slide.logo"
                  :id="slide.id"
                />
                </div>
              </transition-group>
            </div>

          </div>
          <div class="small-1 cell control-cont" @click="next">
            <img tabindex="18" class="next-arrow" src="@/assets/img/icons/right.png" @keypress="next" />
          </div>
    </div>
</template>

<script>

import TestimonialCarouselSlide from './testimonialCarouselSlide';
import TestimonialCarouselButton from './testimonialCarouselButton';

export default {
  name: 'TestimonialCarousel',
  components: {
    'testimonial-carousel-slide': TestimonialCarouselSlide,
    'testimonial-carousel-button': TestimonialCarouselButton,
  },
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      w: window.width,
      largeText: null,
      smallText: null,
      currentSlide: 0,
      timeOut: 12000,
      renderedSlides: [],
    };
  },
  computed: {
    isCurrentButton(id) {
      return this.currentSlide === id;
    },
  },
  mounted() {
    this.renderedSlides = this.$props.slides;
    this.intervalid1 = setInterval(() => {
      this.next();
    }, this.timeOut);
  },
  beforeDestroy() {
    clearInterval(this.intervalid1);
  },
  methods: {
    resetInterval() {
      clearInterval(this.intervalid1);
      this.intervalid1 = setInterval(() => {
        this.next();
      }, this.timeOut);
    },
    next() {
      const firstSlide = this.renderedSlides.shift();
      const length = this.renderedSlides.length;

      this.renderedSlides = this.renderedSlides.concat(firstSlide);
      this.currentSlide += 1;
      if (this.currentSlide > length) { this.currentSlide = 0; }
      this.resetInterval();
    },
    previous() {
      const lastSlide = this.renderedSlides.pop();
      const length = this.renderedSlides.length;

      this.renderedSlides = [lastSlide].concat(this.renderedSlides);
      this.currentSlide -= 1;
      if (this.currentSlide < 0) { this.currentSlide = length; }
      this.resetInterval();
    },
    moveCarousel(id) {
      const currentSlide = this.currentSlide;
      const stepsToMove = id - currentSlide;

      if (id < currentSlide) {
        for (let i = 0; i > stepsToMove; i -= 1) {
          this.previous();
        }
      } else if (id > currentSlide) {
        for (let i = 0; i < stepsToMove; i += 1) {
          this.next();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .transition-group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }

  .button-container {
    width: 100%;
    height: 115px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .control-cont {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media only screen and (max-width: 800px)  {
    .control-cont {
      max-height: 600px;
    }

    .prev-arrow {
      height: auto !important;
    }

    .next-arrow {
      height: auto !important;
    }

  }

  @media only screen and (min-width: 800px)  {
    .testimonials-carousel {
      min-height: 660px;
    }

    .control-cont {
      max-height: 560px;
    }
  }

  .carousel-view {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 30px;
  }

  .carousel {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    overflow: hidden;
  }

  .slide {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .prev-arrow {
    cursor: pointer;
    display: inline-flex;
    width: 48px;
    height: 48px;
  }

  .next-arrow {
    cursor: pointer;
    display: inline-flex;
    width: 48px;
    height: 48px;
  }

</style>



// WEBPACK FOOTER //
// src/components/carousels/testimonialCarousel/testimonialCarousel.vue